import { render, staticRenderFns } from "./crm-notification-menu.vue?vue&type=template&id=14d6c668&"
import script from "./crm-notification-menu.vue?vue&type=script&lang=js&"
export * from "./crm-notification-menu.vue?vue&type=script&lang=js&"
import style0 from "./crm-notification-menu.vue?vue&type=style&index=0&id=14d6c668&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports